import { render, staticRenderFns } from "./OperaManagerWindow.vue?vue&type=template&id=6cabfefe&"
import script from "./OperaManagerWindow.vue?vue&type=script&lang=js&"
export * from "./OperaManagerWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports